import * as AD2 from "lib/at-data/AsyncData2";
import { GranulatedSeriesRequest } from "lib/at-data/requests/temporal/GranulatedSeriesRequest";
import * as DS from "lib/at-data/DataSeries";
import { TimebarState } from "./state";

export const initialState: TimebarState = {
  timebarSeries: AD2.none,
};
